import { getUrlAllParams, getUrlParam } from '@/libs/functions/getValue'
import goTo from '@/libs/functions/goTo'
import { getStorage } from '@/libs/functions/onStorage'

interface IUrlProps {
  type: string
  redirectUrl: string
  channel: string
}

// 中转页
export default function TransferPage() {
  const type = getUrlParam('type') || 'url'
  const redirectUrl = getUrlParam('redirectUrl') || ''
  const channel = getUrlParam('channel')
  // const params: IUrlProps = getUrlAllParams()
  // const { type = 'url', redirectUrl = '', channel = '' } = params
  const _redirectUrl = decodeURIComponent(redirectUrl)
  const h5Token = getStorage('h5Token')
  if (type === 'url') {
    if (channel === 'youchu') {
      const seg = _redirectUrl.indexOf('?') > -1 ? '&' : '?'
      goTo(`${_redirectUrl}${seg}h5Token=${h5Token}`, {
        type: 'replace',
      })
    } else {
      goTo(_redirectUrl, {
        type: 'replace',
      })
    }
  }
  return <></>
}
